export default "__VITE_ASSET__CTKU7MvU__"